export default __webpack_public_path__ + "static/media/Arrow_Dropdown.d3262903.svg";